import { render, staticRenderFns } from "./CheckboxProp.vue?vue&type=template&id=0a7111ef&"
import script from "./CheckboxProp.vue?vue&type=script&lang=js&"
export * from "./CheckboxProp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports